<app-bread-crumb [items]="[{text:  'servicos',link:'/admin/services'},{text:pageTitle}]"
  [sectionTitle]="pageTitle"></app-bread-crumb>

  <section class="content">

    <form [formGroup]="objectForm" novalidate (ngSubmit)="submitForm()">

    <ng-box [boxIcon]="'fa  fa-wrench'" [boxTitle]="'Dados do Serviço'" [showBoxFooter]="true">

        <!-- cabesalho do box -->
      <ng-container class="ng-box-header">
        <ng-button (click)="back()" [button]="{name:'back',faIconClass:'fa fa-arrow-left',color:'secondary'}"></ng-button>
      </ng-container>

      <!-- conteudo do box -->
      <ng-container class="ng-box-content">

          <div class="row">

            <div class="col-md-4">

              <div class="form-group">

                <app-input label="Parceiro(*)" errorMessage="Campo obrigatório">

                  <select formControlName="partners_id" class="form-control">
                    <option *ngFor="let partner of partners" [value]="partner.id">{{partner.name}}</option>
                  </select>

                </app-input>
                
              </div>

            </div>

            <div class="col-md-4">

              <div class="form-group">

                <app-input label="Nome do Serviço(*)" errorMessage="Campo obrigatório">
                  <input type="text" formControlName="name" class="form-control">
                </app-input>

              </div>

            </div>
            <div class="col-md-4">

              <div class="form-group">

                <app-input label="Formato do Bónus(*)" errorMessage="Campo obrigatório">
                  <select formControlName="percentagems_id" class="form-control">
                    <option *ngFor="let format of bonusFormats" [value]="format.id">{{format.description}}</option>
                  </select>
                </app-input>

              </div>

            </div>

          </div>

          <div class="row">

            <div class="col-md-4">

              <div class="form-group">

                <app-input label="Bónus Khuzela(*)" errorMessage="- Campo obrigatório;- Somente números são permitidos;">
                  <input type="text" formControlName="khuzelaBonus" class="form-control">
                </app-input>
                
              </div>

            </div>

            <div class="col-md-4">

              <div class="form-group">

                <app-input label="Bónus Clube(*)" errorMessage="- Campo obrigatório;- Somente números são permitidos;">
                  <input type="text" formControlName="clubBonus" class="form-control">
                </app-input>
                
              </div>

            </div>

            <div class="col-md-4">

              <div class="form-group">

                <app-input label="Bónus Sócio(*)" errorMessage="- Campo obrigatório;- Somente números são permitidos;">
                  <input type="text" formControlName="partnerBonus" class="form-control">
                </app-input>
                
              </div>

            </div>

          </div>

          <div class="row">

            <div class="col-md-12">

              <div class="form-group">

                <app-input label="Descrição do Serviço" errorMessage="Campo obrigatório">
                  <textarea formControlName="description" class="form-control"  rows="4"></textarea>
                </app-input>

              </div>

            </div>

          </div>
          

        </ng-container>
        
        <!-- footer -->
        <ng-container class="ng-box-footer">

          <div class="row">
            <div class="col-xs-12">
                <ng-button *ngIf="isAdmin()"  class="pull-right" [button]="{
                    name:'salvar',
                    color:'danger',
                    faIconClass:'fa fa-save',
                    type:'submit',
                    loadingText:'SALVANDO',
                    isLoading:isButtonLoading,
                    isDisabled:isButtonLoading || objectForm.invalid}">
                </ng-button>
          </div>

        </div>

      </ng-container>
      
    </ng-box>
  </form>

  </section>